import router from "../router";

export const plantsList = (state, plants) => {
  state.plants = plants;
};

export const activePage = (state, activePage) => {
  state.activePage = activePage;
};

export const resetLife = (state) => {
  state.life = 0;
};

export const changeLife = (state, life) => {
  state.life = life;
};

export const changeScore = (state) => {
  state.score = state.score + 1;
};

export const resetScore = (state) => {
  state.score = 0;
};

export const losingLife = (state) => {
  if (state.life === 0) return;
  state.life = state.life - 0.5;
};

export const backPage = (state) => {
  switch (state.activePage) {
    case "level":
      router.push({ name: "Home" });
      break;
    case "family":
      state.activePage = "level";
      break;
    case "game":
      state.activePage = "family";
      break;
    case "quizz":
      state.activePage = "game";
      break;
  }
};

export const chooseGame = (state, game) => {
  switch (game) {
    case 1:
      state.game = 1;
      break;
    case 2:
      state.game = 2;
      break;
  }
};

export const chooseFamily = (state, family) => {
  if (family === 0) {
    return;
  }
  state.family = family;
};

export const chooseDifficulty = (state, difficulty) => {
  state.difficulty = difficulty;
};
